export class GameReelsStats {
	public static TIME_SINCE_SPIN_PRESSED: number = 0;
	public static MINIMUM_TIME_TO_FINISH_DROP: number = 0;
	public static EXPECTED_TIME_ON_REGULATED_MARKET: number = 0;
	public static IS_ON_REGULATED_MARKET: boolean = false;
}



// WEBPACK FOOTER //
// ./src/avalanche/GameReelsStats.ts